import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ametist-stone.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ebd2e87e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "banner",
  class: "ametist-promotion",
  "aria-label": "Реклама сервиса знакомств Аметист"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "ametist-promotion__image",
  src: _imports_0,
  alt: "",
  width: "84",
  height: "72"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ametist-promotion__copy" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ametist-promotion__label" }, "Реклама · 18+"),
  /*#__PURE__*/_createElementVNode("h2", null, "Аметист. Знакомства для серьёзных отношений"),
  /*#__PURE__*/_createElementVNode("p", null, "Найдите человека с близкими ценностями. Для отношений, семьи и общего будущего.")
], -1))
const _hoisted_4 = { class: "ametist-promotion__actions" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: _ctx.landingUrl,
        target: "_blank",
        rel: "noopener noreferrer sponsored",
        class: "ametist-promotion__cta",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.trackClick && _ctx.trackClick(...args))),
        onAuxclick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.trackAuxClick && _ctx.trackAuxClick(...args)))
      }, " Найти своего человека ", 40, _hoisted_5),
      _createElementVNode("a", {
        href: _ctx.homeUrl,
        target: "_blank",
        rel: "noopener noreferrer sponsored",
        class: "ametist-promotion__site",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.trackClick && _ctx.trackClick(...args))),
        onAuxclick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.trackAuxClick && _ctx.trackAuxClick(...args)))
      }, "ametist.love", 40, _hoisted_6)
    ])
  ], 512))
}